import React, { Component } from 'react';
import Table from 'components/shared/table';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import InlineButton from 'components/shared/LinkButton';
import EditForm from './shared/EditForm';

class WorkspaceRow extends Component {
  state = {
    editing: false,
  };

  toggleEditing = () => {
    this.setState(state => ({ editing: !state.editing }));
  };

  handleDelete = () => {
    const { workspace } = this.props;
    // eslint-disable-next-line
    if (!confirm(t('workspaces.confirm_delete', { name: workspace.name }))) {
      return;
    }
    this.setState({ loading: true }, () => {
      request
        .delete(routes.WORKSPACES.WORKSPACE(workspace.id))
        .then(() => this.props.onDelete(workspace))
        .fail(() => this.setState({ loading: false }));
    });
  };

  handleUpdate = workspace => {
    this.setState({ loading: true, error: null }, () => {
      request
        .put(routes.WORKSPACES.WORKSPACE(workspace.id), { workspace })
        .then(response => {
          this.setState({ loading: false }, () => {
            this.toggleEditing();
            this.props.onUpdate(response.workspace);
          });
        })
        .fail(({ responseJSON }) =>
          this.setState({ error: responseJSON, loading: false }),
        );
    });
  };

  renderEditForm() {
    const { loading, error } = this.state;
    const { workspace } = this.props;
    const formProps = { loading, error, workspace };
    return (
      <Table.Row>
        <Table.Body.Cell>
          <EditForm {...formProps} onSubmit={this.handleUpdate}>
            <EditForm.Cancel onClick={this.toggleEditing} />
            <EditForm.Submit>{t('common.save_changes')}</EditForm.Submit>
          </EditForm>
        </Table.Body.Cell>
      </Table.Row>
    );
  }

  render() {
    const { loading, editing } = this.state;
    const {
      workspace: { number_of_items: count, name, id },
      disabled,
    } = this.props;

    if (editing) {
      return this.renderEditForm();
    }

    const deleteTooltipProps = count > 0 && {
      'data-toggle': 'tooltip',
      'data-original-title': id
        ? t('workspaces.cannot_delete_tooltip')
        : t('workspaces.cannot_delete_default_tooltip'),
      title: id
        ? t('workspaces.cannot_delete_tooltip')
        : t('workspaces.cannot_delete_default_tooltip'),
      tabIndex: 0,
    };

    return (
      <Table.Row>
        <Table.Body.Cell size="xl">
          <span className="fw-b">{name}</span>
        </Table.Body.Cell>
        <Table.Body.Cell center>{t('common.items', { count })}</Table.Body.Cell>
        <Table.Body.Cell center contentClassName="w-110 pos-i fd-r ai-c">
          <InlineButton
            onClick={this.toggleEditing}
            disabled={loading || disabled}
          >
            {t('common.edit')}
          </InlineButton>
          <span className="c-brand-gray-light">|</span>
          {/*
            This following button is awkwardly structured as a workaround to fix
            Bootstrap tooltips on disabled buttons (happens only in FF and IE)
            https://getbootstrap.com/docs/4.1/components/tooltips/#disabled-elements
          */}
          <span {...deleteTooltipProps}>
            <InlineButton
              onClick={this.handleDelete}
              disabled={count > 0 || loading || disabled}
              className={count > 0 ? 'pe-n' : ''}
            >
              {t('common.delete')}
            </InlineButton>
          </span>
        </Table.Body.Cell>
      </Table.Row>
    );
  }
}

export default WorkspaceRow;
